import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import GenericReturn from 'app/model/generic/generic-return.model';
import NotificacaoModel from 'app/model/notificacao/notificacao.model';
import {environment} from 'environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class NotificacaoService {

  private countSubject = new BehaviorSubject<number>(0);
  count$ = this.countSubject.asObservable();

  updateCount(count: number) {
    this.countSubject.next(count);
  }

  getCountValue(): number {
    return this.countSubject.value;
  }

  apiURL = environment.API;

  httpOptions = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient,
              private router: Router) {
  }

  buscarNotificacoes(): Observable<GenericReturn<NotificacaoModel[]>> {
    return this.httpClient
      .get<GenericReturn<NotificacaoModel[]>>(this.apiURL + '/notificacao/buscar-notificacoes-rm', this.httpOptions);
  }

  buscarNotificacoesNaoLidas(): Observable<GenericReturn<NotificacaoModel[]>> {
    return this.httpClient
      .get<GenericReturn<NotificacaoModel[]>>(this.apiURL + '/notificacao/buscar-notificacoes-rm-nao-lidas', this.httpOptions);
  }

  marcarComoLido(id: number): Observable<GenericReturn<null>> {
    return this.httpClient
      .post<GenericReturn<null>>(this.apiURL + `/notificacao/notificacao-lida?notificacaoId=${id}`, null, this.httpOptions);
  }

  marcarComoNaoLido(id: number): Observable<GenericReturn<null>> {
    return this.httpClient
      .post<GenericReturn<null>>(this.apiURL + `/notificacao/notificacao-nao-lida?notificacaoId=${id}`, null, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/notificacao/notificacao.service.ts